import { render } from "./TotalPerTermChart.vue?vue&type=template&id=355b94a9"
import script from "./TotalPerTermChart.vue?vue&type=script&lang=js"
export * from "./TotalPerTermChart.vue?vue&type=script&lang=js"
script.render = render

export default script